import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {

  messages = [
    { week_number: 1, messages: [1, 2] },
    { week_number: 2, messages: [1, 2, 3] },
    { week_number: 3, messages: [1, 2] },
    { week_number: 4, messages: [1, 2, 3, 4] },
    { week_number: 5, messages: [1, 2, 3] },
    { week_number: 6, messages: [1, 2, 3, 4] },
    { week_number: 7, messages: [1, 2, 3] },
    { week_number: 8, messages: [1, 2] },
  ]
  week_number = 1
  message = null

  constructor(
    private route: ActivatedRoute,
  ) {
    this.week_number = Number(this.route.snapshot.params.week_number)
    this.message = this.messages.filter(m => m.week_number == this.week_number).pop();
  }

}
